// IE 2026 10 13 / ODOO-5800 (приёмка Игоря: блок паспорта «Responsibles» — ссылка на список реестра ответственных была только текстом section.list): чистая часть — как из секции паспорта
// собрать открытие списка реестра с отбором по scope ячейки. Без Vue и DOM (юнит-тест tests/unit/passportRegisterLink.test.mjs).
// Бэк (common_modules/responsible_register_views.section): section.list = { widget: 'widget-list-responsible-register', scopes: [{scope_type, scope_key, row_id, missing}] }.
// Отбор: doc.scope_key in <ключи scope секции> (+ doc.scope_type =, когда тип один). Измерения (dims) ячейки в отбор НЕ идут: строка реестра несёт подмножество измерений
// (пусто / '*' — любое значение), равенство по dims спрятало бы более общие строки, которые тоже применяются к ячейке. Выключатель fe.passport.responsiblesLink (читает Dropdown.vue).
import { t } from '@/i18n'

// секция → { widget, keys: [уникальные scope_key по порядку], types: [уникальные scope_type] } | null (нет списка или нет ни одного ключа scope — открывать нечего, не гадаем)
export function registerLink_spec(sec) {
    const l = sec && typeof sec === 'object' ? sec.list : null
    if (!l || typeof l !== 'object') return null
    const widget = String(l.widget ?? '').trim()
    if (!widget) return null
    const keys = [], types = []
    for (const s of Array.isArray(l.scopes) ? l.scopes : []) {
        const k = String(s?.scope_key ?? '').trim(), ty = String(s?.scope_type ?? '').trim()
        if (!k) continue
        if (!keys.includes(k)) keys.push(k)
        if (ty && !types.includes(ty)) types.push(ty)
    }
    return keys.length ? { widget, keys, types } : null
}

// строки WHERE чипса CHIP-Where (формат utils/cellRules.cellRules_commonWhere): один ключ — «=», несколько — «in» со списком attrs
function _row(binding, label, values) {
    if (values.length === 1) return { use: true, leftValue: { value: binding, valueStr: label }, condition: '=', rightValue: { value: values[0], valueStr: String(values[0]) } }
    return { use: true, leftValue: { value: binding, valueStr: label }, condition: 'in', rightValue: { value: '', valueStr: '' }, attrs: values.map(v => ({ use: true, rightValue: { value: v, valueStr: v } })) }
}

export function registerLink_where(spec) {
    if (!spec || !Array.isArray(spec.keys) || !spec.keys.length) return []
    const out = []
    if (Array.isArray(spec.types) && spec.types.length === 1) out.push(_row('doc.scope_type', t('Scope type'), spec.types))
    out.push(_row('doc.scope_key', t('Scope key'), spec.keys))
    out.push(_row('doc.use', t('Use'), [true]))   // IE 2026 10 13 / ODOO-5800: только действующие строки реестра (use = true), выключенные в список паспорта не попадают
    return out
}

// подпись чипса: «Register: key1 · key2 +N»
export function registerLink_title(spec) {
    const ks = (spec && spec.keys) || []
    return t('Register: {what}', { what: ks.slice(0, 2).join(' · ') + (ks.length > 2 ? ' +' + (ks.length - 2) : '') })
}

// ссылка строки секции {kind: 'widget', id} (бэк: строка «Register list»): открываемая, когда в секции есть список; id совпадает с section.list.widget
export function registerLink_isRowLink(l, spec) {
    return !!(l && typeof l === 'object' && l.kind === 'widget' && l.id && spec && String(l.id) === spec.widget)
}
